import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './LandingPage.css';
import logoImage from '../img/citylink_logo.webp';
import { API_BASE } from '../config/apiConfig';

const LandingPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      if (sessionStorage.getItem('loggedOut') === '1') {
        sessionStorage.removeItem('loggedOut');
        setIsAuthenticated(false);
        setIsAdmin(false);
        return;
      }
      try {
        const response = await axios.get(`${API_BASE}/auth/me`, { withCredentials: true });
        if (response.data?.success && response.data.user) {
          setIsAuthenticated(true);
          setIsAdmin(response.data.user.role === 'admin');
        } else {
          setIsAuthenticated(false);
          setIsAdmin(false);
        }
      } catch {
        setIsAuthenticated(false);
        setIsAdmin(false);
      }
    };
    checkAuth();
  }, []);

  useEffect(() => {
    const steps = document.querySelectorAll('.landing-step');
    const sectionHead = document.querySelector('#how .landing-section-head');
    if (!steps.length && !sectionHead) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          if (entry.target.classList.contains('landing-step')) {
            entry.target.classList.add('landing-step-visible');
          } else if (entry.target.id === 'how-section-head') {
            entry.target.classList.add('landing-section-head-visible');
          }
        });
      },
      {
        // Wait until at least half of the element is visible,
        // and slightly shrink the bottom of the viewport so
        // the trigger happens closer to the middle of the screen.
        threshold: 0.5,
        rootMargin: '0px 0px -20% 0px'
      }
    );

    steps.forEach(step => observer.observe(step));
    if (sectionHead) {
      // give it a stable id so we can distinguish in the observer
      sectionHead.id = 'how-section-head';
      observer.observe(sectionHead);
    }

    return () => observer.disconnect();
  }, []);

  return (
  <div className="landing">
    <nav className="landing-nav">
      <div className="landing-nav-inner">
        <Link to="/" className="landing-logo">
          <span className="landing-logo-mark">
            <img src={logoImage} alt="CityLink logo" className="landing-logo-img" />
          </span>
          <span className="landing-logo-title">
            <span className="landing-logo-city">CITY</span>
            <span className="landing-logo-link">LINK</span>
          </span>
        </Link>
        <div className="landing-nav-mid">
          <a href="#how" className="landing-nav-link">How it works</a>
        </div>
        <div className="landing-nav-links">
          {isAuthenticated ? (
            <Link to={isAdmin ? '/admin' : '/dashboard'} className="landing-nav-cta primary">
              {isAdmin ? 'Admin' : 'Dashboard'}
            </Link>
          ) : (
            <Link to="/sign-in" className="landing-nav-cta primary">
              Sign in
            </Link>
          )}
        </div>
      </div>
    </nav>

    <section className="landing-hero">
      <div className="landing-hero-inner">
        <div className="landing-hero-left">
          <div className="landing-hero-content">
            <div className="landing-hero-kicker hero-anim-1">FOR CITIES & RESIDENTS</div>
            <h1 className="landing-hero-title hero-anim-2">
              One place for permits<br />and city issues.
            </h1>
          <p className="landing-hero-sub hero-anim-3">
            Apply for permits and report problems online —
            <br />
            no more phone tag or paper forms.
          </p>
            <div className="landing-hero-ctas hero-anim-4">
              {isAuthenticated ? (
                <Link to={isAdmin ? '/admin' : '/start'} className="landing-btn primary large">
                  Go to CityLink
                </Link>
              ) : (
                <a href="#how" className="landing-btn secondary large">
                  Learn more
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>

    {/*
    <section className="landing-trusted">
      <p className="landing-trusted-label">Trusted by</p>
      <div className="landing-trusted-logos">
        <span className="landing-trusted-item">West Lafayette, IN</span>
        <span className="landing-trusted-item">Indianapolis, IN</span>
      </div>
    </section>
    */}

    <section id="how" className="landing-product">
      <div className="landing-section-head">
        <h2 className="landing-section-title">Get Started Today</h2>
      </div>
      <div className="landing-steps">
        <div className="landing-step">
          <div className="landing-step-text">
            <h3>Pick your city</h3>
            <p>Choose your city and county.</p>
          </div>
          <div className="landing-step-visual" aria-hidden="true" />
        </div>
        <div className="landing-step">
          <div className="landing-step-text">
            <h3>Pick what you need</h3>
            <p>Start a permit or report an issue.</p>
          </div>
          <div className="landing-step-visual" aria-hidden="true" />
        </div>
        <div className="landing-step">
          <div className="landing-step-text">
            <h3>Watch the status</h3>
            <p>See updates in one place.</p>
          </div>
          <div className="landing-step-visual" aria-hidden="true" />
        </div>
      </div>
    </section>

    <footer className="landing-footer">
      <div className="landing-footer-inner">
        <p className="landing-footer-copy">© {new Date().getFullYear()} SingularX Inc.</p>
      </div>
    </footer>
  </div>
  );
};

export default LandingPage;
